import Messenger, { onHide, onShow } from "@intercom/messenger-js-sdk";
import jwt_decode from "jwt-decode";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import getToken from "web/utils/system/essentials/getToken";
import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";

import { Functionality } from "web/types/Employee";

import { useAppContext } from "web/context/app";
import { useGetCustomerDetailsQuery } from "web/features/customer/customerApiSlice";
import {
  useGetEmployeeDetailsQuery,
  useGetEmployeeIntercomQuery,
} from "web/features/employee/employeeApiSlice";

enum Regions {
  EU = "eu",
}

const Intercom = () => {
  // set to test instance if env value doesn't exist
  const appId = process.env.INTERCOM_APP_ID || "w3260b93";
  const [isIntercomAccessGranted, setIsIntercomAccessGranted] = useState(false);
  const [isIntercomDisabledForRoute, setIsIntercomDisabledForRoute] =
    useState(false);
  const { data: employeeDetails } = useGetEmployeeDetailsQuery();
  const { data: customer } = useGetCustomerDetailsQuery();
  const { data: intercom } = useGetEmployeeIntercomQuery();
  const location = useLocation();
  const [ssoUid, setSsoUid] = useState<string>("");
  const { isMobile } = useAppContext();

  useEffect(() => {
    setIsIntercomAccessGranted(
      !!employeeDetails?.functionalities?.find(
        (value: string) => value === Functionality.ENABLE_INTERCOM
      )
    );
  }, [employeeDetails]);

  useEffect(() => {
    setIsIntercomDisabledForRoute(location.pathname.includes("checkout"));
  }, [location]);

  useEffect(() => {
    try {
      const localStorageToken =
        localStorage.getItem("FENIKS_BROWSER_PERSISTENCE__tokenAccess") || "";

      if (localStorageToken === "") {
        const InitializeIntercom = async () => {
          const token = await getToken();
          const { MyB_SSO_UID } = token
            ? jwt_decode<{ MyB_SSO_UID: string }>(token.accessToken)
            : { MyB_SSO_UID: "" };
          setSsoUid(MyB_SSO_UID);
        };
        InitializeIntercom();
      } else {
        setSsoUid(
          jwt_decode<{ MyB_SSO_UID: string }>(
            JSON.parse(localStorageToken)?.value
          ).MyB_SSO_UID
        );
      }
    } catch (error) {
      newRelicErrorReport(error, "web-app/web/Components/Intercom.tsx - 68");
      console.error(error);
    }
  }, []);

  if (!intercom?.hash) {
    return null;
  }

  if (isIntercomAccessGranted && !isIntercomDisabledForRoute && ssoUid !== "") {
    Messenger({
      app_id: appId,
      user_hash: intercom.hash,
      user_id: ssoUid,
      region: Regions.EU,
      name: `${customer?.firstname} ${customer?.lastname}`,
      language_override: customer?.language
        ? customer?.language.slice(0, 2)
        : "pl",
      user_language_mybenefit: customer?.language
        ? customer?.language.slice(0, 2)
        : "pl",
      background_color: "#102b3f",
      action_color: "#102b3f",
      has_mybenefit_id: true,
      ...(isMobile && {
        custom_launcher_selector: "#customIntercomLauncher",
        hide_default_launcher: true,
      }),
    });
    onShow(() => {
      window.isIntercomPanelVisibleToUser = true;
    });
    onHide(() => {
      window.isIntercomPanelVisibleToUser = false;
    });
  }

  return null;
};

export default Intercom;
